module.exports = __webpack_public_path__ + "img/mt5-icon5.a7dc5a2.png";